import { credentials as globalCredentials } from "@shared/locales/en/US/credentials";

const credentials = {
  ...globalCredentials,
} as const;

export { credentials };
